module.exports = __webpack_public_path__ + "6884e6fb72dcd32b7c256dd820aab45f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/owl_hoots/snowy_owl_hoot.png
// module id = 2891
// module chunks = 0